import { api } from "@/apiInstance";
import { requestedFeaturesQueryOptions } from "@/queries/featureRequests/requestedFeaturesQuery";
import { formdataFromObj } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export interface FeatureFormValues {
  title: string;
  details: string;
  files?: File[];
}

export const useSuggestFeature = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: ["suggest-feature"],
    mutationFn: async (data: FeatureFormValues) => {
      const response = await api.post(api.endpoints.requestFeature, formdataFromObj(data));

      await queryClient.invalidateQueries(requestedFeaturesQueryOptions());

      return response.data;
    },
  });

  return mutation;
};
